export enum MapShape {
    RoundDot = 1,
    Triangle = 2,
    Diamond = 3,
    Pentagram = 4,
    Square = 5,
    FourPointStar = 6,
    FivePointStar = 7,
    SixPointStar = 8,
    Octagon = 9,
}

export const MapShapeOptions = {
    [MapShape.RoundDot]: 'Round Dot',
    [MapShape.Triangle]: 'Triangle',
    [MapShape.Square]: 'Square',
    [MapShape.Diamond]: 'Diamond',
    [MapShape.Pentagram]: 'Pentagram',
    [MapShape.Octagon]: 'Octagon',
    [MapShape.FourPointStar]: 'Four Point Star',
    [MapShape.FivePointStar]: 'Five Point Star',
    [MapShape.SixPointStar]: 'Six Point Star',
};
